import React from "react";
import { ButtonGroup, Button } from "reactstrap";
import { Spinner } from "react-activity";
export const renderReservationActions = (openSchedule, deleteReservation, getResevationRooms, openMembersList, cellInfo) => {
  const reservationTarget = cellInfo.original && cellInfo.original.id ? cellInfo.original : cellInfo.index;
  return (
    <ButtonGroup className="reservations-action-group">
      <Button
        color="faiz1"
        title="Open schedule"
        onClick={() => {
          openSchedule(reservationTarget);
        }}
      >
        <i style={{ color: "white" }} className="fa  fa-calendar" />
      </Button>
      <Button
        color="faiz2"
        title="Manage rooms"
        onClick={() => {
          getResevationRooms(reservationTarget);
        }}
      >
        {cellInfo.original.isRoomLoading ? <Spinner size={10} animating={true} color={"white"} /> : <i className="fa fa-bed" />}
      </Button>
      <Button
        color="faiz3"
        title="View members"
        onClick={() => {
          openMembersList(reservationTarget);
        }}
      >
        <i className="fa fa-users" />
      </Button>
      <Button
        color="danger"
        title="Delete reservation"
        onClick={() => {
          deleteReservation(reservationTarget);
        }}
      >
        <i className="fa  fa-trash" />
      </Button>
    </ButtonGroup>
  );
};

export const renderReservationRoomActions = (deleteRoom, cellInfo) => {
  return (
    <ButtonGroup className="reservations-action-group">
      <Button
        color="danger"
        title="Delete room"
        onClick={() => {
          deleteRoom(cellInfo.index);
        }}
      >
        <i className="fa  fa-trash" />
      </Button>
    </ButtonGroup>
  );
};
